module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6sfc6nNAwJiPhGVidYuEwC-d115c36b251b0918500303e7041b1509.jpg";